import { render, staticRenderFns } from "./ProductsMenu.vue?vue&type=template&id=3e32b5ae&scoped=true&"
import script from "./ProductsMenu.vue?vue&type=script&lang=js&"
export * from "./ProductsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductsMenu.vue?vue&type=style&index=0&id=3e32b5ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e32b5ae",
  null
  
)

export default component.exports